import React, { useState } from "react";
import addToMailchimp from 'gatsby-plugin-mailchimp';
import { withPrefix } from "gatsby"
import BlockContent from '@sanity/block-content-to-react';
import { generateImageUrl } from "../../sanityConfig";
const BlogPostRightContent = ({ rightContent }) => {
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState(null)
    const submitHandler = (e) => {
        e.preventDefault();
        setLoading(true)
        addToMailchimp(email).then(res => {
            if (res.result === "success") {
                setMessage(res)
            }
            else {
                setMessage({
                    msg: "This email is already subscribed to list Delicious Experiences.",
                    result: res.result
                })
            }
            setLoading(false)
        })
    }
    return (
        <div>
            <div className="lg:block hidden">
                <a href="/">
                    <img className="mt-8 mx-auto" src={generateImageUrl(rightContent?.image?.asset).url()} alt="About delicious experiences" />
                </a>
                <div className="my-8">
                    <p className="text-center font-semibold text-xl">Delicious Experiences</p>
                    <div className="font-freight text-sm text-center mt-8">
                        <BlockContent blocks={rightContent.aboutDeliciousExperiences} />
                    </div>
                </div>
            </div>
            <div className="lg:hidden border-t pt-8 mt-16 border-gray-300">
                <div className="flex items-center">
                    <div className="h-20 w-20 rounded-full bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url(${withPrefix('/images/icon-image.png')})` }} />
                    <p className="text-2xl font-bold ml-4">Delicious<br />Experiences</p>
                </div>
                <div className="font-freight text-sm mt-4"> <BlockContent blocks={rightContent.aboutDeliciousExperiences} /></div>
            </div>
            <div className="mt-16">
                <div className="bg-contact-yellow p-8 flex flex-col items-center">
                    <h1 className="text-black text-2xl font-semibold text-center">Join Our Newsletter</h1>
                    <p className="text-sm text-black font-freight text-center mt-4">Enter your email and we'll keep you posted with news and updates!</p>
                    <form className="w-full relative" onSubmit={(e) => submitHandler(e)}>
                        <input onChange={(e) => setEmail(e.target.value)} required type="email" className="mt-4 bg-white w-full py-4 focus:outline-none text-xs pl-2 font-semibold border" placeholder="Enter Your E-mail.." />
                        <button className="uppercase bg-green-700 hover:bg-green-800 w-full py-4 text-sm mt-4 text-white font-semibold transition duration-500">{loading ? "SUBMITTING..." : "SUBSCRIBE"}</button>
                    </form>
                    {
                        message &&

                        <p className={`text-xs pt-4 ${message.result === "success" ? "text-green-500" : "text-red-500"}`}>{message.msg}</p>
                    }
                </div>
            </div>
        </div>
    )
}
export default BlogPostRightContent;